const viewport = "width=device-width, initial-scale=1, maximum-scale=1";

module.exports = viewport;
